import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';

const imgService = require('../assets/logo.png');

const styles = {
  root: {
    flexGrow: 1,
    background: 'white',
    color: 'white',
  },
  logo: {
    width: 300,
  },
  toolbar: {
    background: 'white',
    minHeight: 30,
    alignItems: 'flex-start',
    paddingTop: 10,
    paddingBottom: 10,
  },
};

function TopBar(props) {
  const { classes } = props;

  return (
    <div className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <Box p={1} flexGrow={1}> <img src={imgService} alt="" className={classes.logo} /></Box>
        </Toolbar>
    </div>
  );
}

export default withStyles(styles)(TopBar);